<template>
  <div>
    <v-icon @click="checkLocationEnable" v-if="locationEnabled">{{ mdiMapMarkerCheck }}</v-icon>
    <v-icon @click="checkLocationEnable" v-else>{{ mdiMapMarkerOff }}</v-icon>
  </div>
</template>

<script>
import { mdiMapMarkerCheck, mdiMapMarkerOff } from '@mdi/js';
import location from '../mixins/location';

export default {
  name: 'Location',
  mixins: [location],
  data() {
    return {
      mdiMapMarkerCheck,
      mdiMapMarkerOff,
      locationEnabled: false,
      error: undefined,
    };
  },
  mounted() {
    this.checkLocationEnable();
  },
  methods: {
    checkLocationEnable() {
      this.$log.info('checking location enabled');
      this.error = undefined;
      if (navigator.geolocation) {
        const evalError = (error) => {
          this.locationEnabled = false;
          this.error = error;
          // eslint-disable-next-line default-case
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.reason = 'User denied the request for Geolocation.';
              break;
            case error.POSITION_UNAVAILABLE:
              this.reason = 'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              this.reason = 'The request to get user location timed out.';
              break;
            case error.UNKNOWN_ERROR:
              this.reason = 'An unknown error occurred.';
              break;
          }
        };
        const evalSuccess = () => { this.locationEnabled = true; };
        navigator.geolocation.getCurrentPosition(evalSuccess, evalError);
        this.$log.info(`Geolocation is: ${this.locationEnabled}`);
      } else {
        this.reason = 'Geolocation is not supported by this browser.';
        this.error = {
          code: 'unsupported',
        };
      }
      this.$log.info('location check completed');
    },
    tryAgain() {
      this.checkLocationEnable();
      this.$root.$emit('toast:notify', this.$t('common.sent'));
    },
  },
};
</script>
